// frontend/src/components/learning-path/AISuggestionCard.tsx

import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { geminiService, GeminiApiError } from '../../services/gemini.service';
import { LearningPath } from '../../types/courses.types';

interface AISuggestionCardProps {
  path: LearningPath;
}

export function AISuggestionCard({ path }: AISuggestionCardProps) {
  const [suggestion, setSuggestion] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function fetchSuggestion() {
      setIsLoading(true);
      setError(null);
      try {
        const currentStep = path.steps.find((s) => s.status === 'current');
        const prompt = `Öğrenci "${path.title}" kursunda %${path.progressPercent} ilerleme kaydetti. ${
          currentStep ? `Şu anki konusu: "${currentStep.title}".` : ''
        } Ona 2-3 cümlelik, motive edici ve kısa bir ilerleme önerisi yaz. Bir sonraki adımda nelere dikkat etmesi gerektiğini söyle.`;

        const { reply } = await geminiService.sendChatMessage(prompt, []);
        if (!cancelled) setSuggestion(reply);
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof GeminiApiError ? err.message : 'Öneri alınamadı.');
        }
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    }

    fetchSuggestion();
    return () => {
      cancelled = true;
    };
  }, [path.id, path.progressPercent, path.title]);

  return (
    <div className="card path-ai-suggestion-card">
      <div className="path-ai-suggestion-icon">💡</div>
      <div>
        <h4>AI Önerisi</h4>
        {isLoading && <p className="path-ai-suggestion-loading">MinikBot senin için bir öneri hazırlıyor...</p>}
        {error && <p className="path-ai-suggestion-error">{error}</p>}
        {!isLoading && !error && <p>{suggestion}</p>}
        <Link to="/ai-mentor" className="lesson-btn primary sm">
          🤖 AI Mentor'a Git
        </Link>
      </div>
    </div>
  );
}
